$(document).ready(function () {

    // Move all dialogs to <body> so showModal() doesn't scroll to their DOM position
    $('dialog.video-dialog, dialog.image-dialog').each(function () {
        document.body.appendChild(this);
    });

    function getDialogAndTrigger($dialog) {
        const id = $dialog.attr('id');
        const $trigger = $('.dialog-toggle[aria-controls="' + id + '"], .dialog-trigger[aria-controls="' + id + '"]').first();
        return { $dialog, $trigger };
    }

    function focusFirst($dialog) {
        const $focusTarget = $dialog
            .find('[autofocus], [data-dialog-close], a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
            .filter(':visible')
            .first();

        ($focusTarget[0] || $dialog[0]).focus();
    }

    function buildYouTubeEmbedUrl(videoId) {
        return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
    }

    function setDialogVideo($trigger, $dialog) {
        const videoId = $trigger.attr('data-video');
        if (!videoId) {
            return;
        }

        const $iframe = $dialog.find('iframe.video-iframe').first();
        if (!$iframe.length) {
            return;
        }

        $iframe.attr('src', buildYouTubeEmbedUrl(videoId));
    }

    function clearDialogVideo($dialog) {
        const $iframe = $dialog.find('iframe.video-iframe').first();
        if (!$iframe.length) {
            return;
        }

        $iframe.attr('src', '');
    }

    function openDialog($trigger, $dialog) {
        if (!$dialog.length || !$dialog[0] || typeof $dialog[0].showModal !== 'function') {
            return;
        }

        $trigger.attr('aria-expanded', 'true');
        $dialog.data('returnFocusEl', $trigger[0]);

        $dialog.addClass('is-opening');
        $dialog[0].showModal();

        requestAnimationFrame(function () {
            $dialog.removeClass('is-opening');
        });

        setDialogVideo($trigger, $dialog);
        focusFirst($dialog);
    }

    function closeDialog($trigger, $dialog) {
        $trigger.attr('aria-expanded', 'false');

        if (!$dialog[0] || !$dialog[0].open) {
            return;
        }

        $dialog.addClass('is-closing');

        window.setTimeout(function () {
            $dialog.removeClass('is-closing');
            clearDialogVideo($dialog);
            $dialog[0].close();

            const returnEl = $dialog.data('returnFocusEl');
            if (returnEl && typeof returnEl.focus === 'function') {
                returnEl.focus();
            }
        }, 200);
    }

    // Open
    $(document).on('click', '.dialog-toggle, .dialog-trigger', function () {
        const $trigger = $(this);
        const dialogId = $trigger.attr('aria-controls');
        const $dialog = $('#' + dialogId);

        if (!$dialog.length) {
            return;
        }

        openDialog($trigger, $dialog);

        // Init slider once the dialog is open (only runs if present)
        if (typeof initvideoCarousel === 'function') {
            initvideoCarousel($dialog);
        }
    });

    // Close button
    $(document).on('click', '[data-dialog-close]', function () {
        const $dialog = $(this).closest('dialog.video-dialog, dialog.image-dialog');
        const { $trigger } = getDialogAndTrigger($dialog);
        closeDialog($trigger, $dialog);
    });

    // ESC: keep state consistent
    $(document).on('cancel', 'dialog.video-dialog, dialog.image-dialog', function (e) {
        e.preventDefault();
        const $dialog = $(this);
        const { $trigger } = getDialogAndTrigger($dialog);
        closeDialog($trigger, $dialog);
    });

    // Backdrop click close
    $(document).on('click', 'dialog.video-dialog, dialog.image-dialog', function (e) {
        if (e.target !== this) {
            return;
        }

        const $dialog = $(this);
        const { $trigger } = getDialogAndTrigger($dialog);
        closeDialog($trigger, $dialog);
    });

    // If something else closes it, keep aria-expanded + focus + reset video
    $(document).on('close', 'dialog.video-dialog, dialog.image-dialog', function () {
        const $dialog = $(this);
        const { $trigger } = getDialogAndTrigger($dialog);

        $trigger.attr('aria-expanded', 'false');
        clearDialogVideo($dialog);

        const returnEl = $dialog.data('returnFocusEl');
        if (returnEl && typeof returnEl.focus === 'function') {
            returnEl.focus();
        }
    });

});
